export const styles = {
  boxStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { md: "50%", sm: "75%", xs: "90%" },
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 10,
    p: 2, //padding
    maxHeight: "95%",
    overflow: "scroll",
  },
};
